import axiosInstance from '../axiosInterceptor/axiosInstance'

const pauseLivestream = async (broadcastId, orgId) => {
  const url = `v1/orgs/${orgId}/streams/${broadcastId}/pause`
  return axiosInstance.post(url, {})
}

export default pauseLivestream
